import {useGetDetail} from '../context/useQuery'

import {useIntl} from 'react-intl'
import BreadCrumb from 'src/_metronic/layout/components/breadcrumb'
import ProductForm from '../component/Detail'
import {useNavigate} from 'react-router-dom'

export default function ProductDetail() {
  useGetDetail()
  const intl = useIntl()
  const navigate = useNavigate()

  return (
    <>
      <div className='d-flex gap-5 align-items-center'>
        <button
          className='btn btn-primary btn-sm btn-back'
          onClick={() => {
            navigate('/products')
          }}
        >
          <i className='fa fa-arrow-left'></i>
        </button>
        <BreadCrumb currentPage={intl.formatMessage({id: 'PRODUCT.DETAIL'})} />
      </div>
      <div id='kt_app_content_container' className='d-flex flex-column flex-root mt-10'>
        <ProductForm />
      </div>
    </>
  )
}
